import { DrugClass, RequestResult } from "domain/entities/drug-class";
import { DrugClassRepository } from "domain/repositories";

export default class CreateUseCase {
    private drugClassRepository: DrugClassRepository;
    
    public constructor(drugClassRepository: DrugClassRepository) {
        this.drugClassRepository = drugClassRepository
    }

    public async createDrugClass(drugClass: DrugClass, token: Promise<[string | null, string | null]>): Promise<[RequestResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugClassRepository.createDrugClass(drugClass, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}